/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProActiveScannerRule {
    getFixupPrototypeFunction() { return ProActiveScannerRule.fixupPrototype; }

    static newInstance(model: Partial<ProActiveScannerRule>): ProActiveScannerRule {
        let obj = Object.assign(new ProActiveScannerRule(), model);
        ProActiveScannerRule.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProActiveScannerRule>): ProActiveScannerRule {
        if (!model) return null;
        return ProActiveScannerRule.newInstance(<ProActiveScannerRule> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProActiveScannerRule) {
        if (!obj) return;

        models.ProActiveScannerRule.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProActiveScannerRule): boolean {
        Object.setPrototypeOf(obj, ProActiveScannerRule.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * master rule sys id
     */
    rule_id: string;

    /**
     * Specifies if the rule is active
     */
    is_active: boolean;

    /**
     * input parameters the user wants to override
     */
    default_inputs: Array<string>;

}
